export default __webpack_public_path__ + "static/media/warehouseYellow.a50beec6.svg";